import { useRouter } from "next/router";

import { getAbsoluteUrl } from "~/lib/utils";

export const useCanonicalUrl = (url?: string) => {
  const router = useRouter();
  const canonicalUrl = getAbsoluteUrl(url ?? router.asPath);
  return {
    canonicalUrl,
  };
};
